module.exports = __webpack_public_path__ + "img/grayBar.2a988414.svg";